var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('agent-info-comp'),_c('agent-sub-title',[_vm._v("에이전트 리스트")]),_c('div',{staticClass:"data"},[_c('agent-recursion-comp2',{attrs:{"list":_vm.agentList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }